import { forwardRef } from 'react';
import { ChevronDown } from 'lucide-react';
import Field from './Field';
import Icon from './Icon';

// Native select (keyboard and screen-reader behaviour for free), skinned with tokens.
// options: [{ value, label }] or strings.
const Select = forwardRef(function Select({ label, hint, error, options = [], placeholder, className, ...rest }, ref) {
  return (
    <Field label={label} hint={hint} error={error} className={className}>
      {({ id, describedBy, invalid }) => (
        <span className="ui-select-wrap">
          <select ref={ref} id={id} className="ui-input ui-select" aria-describedby={describedBy} aria-invalid={invalid || undefined} {...rest}>
            {placeholder && <option value="">{placeholder}</option>}
            {options.map(o => {
              const v = typeof o === 'string' ? { value: o, label: o } : o;
              return <option key={v.value} value={v.value} disabled={v.disabled}>{v.label}</option>;
            })}
          </select>
          <Icon icon={ChevronDown} />
        </span>
      )}
    </Field>
  );
});
export default Select;
